export default __webpack_public_path__ + "static/media/Simon-Str.dffd34a4.png";